import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  forwardRef,
} from "react";
import moment from "moment";
import ListPageHeader from "../utilities/ListPageHeader";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Pagination,
  Tooltip,
  Box
} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import jwtDecode from "jwt-decode";
import OAuthService from "src/app/auth/services/oAuthService";
import AgGridTable from "../utilities/AgGridTable";
import NumericCellEditorComponent from "./NumericCellEditorComponent";
import {
  DateFromEditorComponent,
  DateToEditorComponent,
} from "./DatepickerEditorComponent";
import { toast } from "react-toastify";
import Select from "react-select";
import {
  DateTypeEditorComponent,
  VendorIdEditorComponent,
} from "./SelectEditorComponent";
import CustomDatePicker from "../utilities/CustomDatePicker";

const GermanVat = () => {
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.discounts}`;
  const germanVatUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.germanVats}`;

  const [rowData, setRowData] = useState([]);
  const [saveOpen, setSaveOpen] = useState(false);
  const [error, setError] = useState(null);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [totalElements, setTotalElements] = useState(0);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [date,setDate] = useState(new Date())
const vendorOptionsRef = useRef([]);

  const token =
    localStorage.getItem("token") && jwtDecode(localStorage.getItem("token"));

  const showDiscountPercent = (props) =>
    props?.value ? <p>{Number(props?.value).toFixed(3)}%</p> : null;

  const handleDateFormat = (props) =>
    props?.value ? moment(props?.value).format("DD-MM-YYYY") : "";
  const formatApiDate = (date) => moment(date).format("YYYY-MM-DD");
  const onSelectionChanged = useCallback(() => {
    const selectedNodes = gridRef.current.api.getSelectedNodes();
    const selectedData =
      selectedNodes.length > 0 ? selectedNodes[0].data : null;
    setSelectedRow(selectedData);
  }, []);
useEffect(() => {
  const loadVendors = async () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}/search/findByActive?active=true`;

    try {
      const vendors = await OAuthService.getList(url);

      const result =
        vendors?.data?._embedded?.factoryVendors?.map((v) => ({
          label: v.name,   
          value: v.id,     
        })) || [];

      setVendorOptions(result);
      vendorOptionsRef.current = result;
    } catch (error) {
      console.error("Vendor fetch error:", error);
    }
  };

  loadVendors();
}, []);
  const handleAddRow = () => {
    if (!gridApi) return;

    const newRow = {
      vendorId: "",
      validFrom: "",
      validTo: "",
  
      rate: "",
      isNew: true,
    };

    let addIndex = rowData?.length;
    const selectedNodes = gridApi.getSelectedNodes();

    if (selectedNodes && selectedNodes.length > 0) {
      const selectedNode = selectedNodes[0];
      addIndex = selectedNode.rowIndex + 1;
    }

    const res = gridApi.applyTransaction({
      add: [newRow],
      addIndex,
    });

  setRowData((prev) => {
    const updated = [...(prev || [])];
    updated.splice(addIndex, 0, newRow);
    return updated;
  });

    if (res.add && res.add.length > 0) {
      const newRowNode = res.add[0];

      setTimeout(() => {
        gridApi.stopEditing();
        gridApi.setFocusedCell(newRowNode.rowIndex, "vendorId");
        gridApi.startEditingCell({
          rowIndex: newRowNode.rowIndex,
          colKey: "vendorId",
        });
      }, 100);
    }
  };
  const handleEditRow = useCallback(() => {
    const selectedRow = gridRef.current.api.getSelectedRows();
    let index = rowData.findIndex((row) => row.id === selectedRow[0].id);
    // let index = rowData?.findIndex((row) => row.id === selectedRow[0].id);
    gridRef.current.api.setFocusedCell(index, "vendorId");
    gridRef.current.api.startEditingCell({
      rowIndex: index,
      colKey: "vendorId",
    });
  }, [rowData]);
  const handleSaveGermanVat = async () => {
    gridApi.stopEditing();

    try {
      const newRows = rowData.filter((row) => row.isNew);
      const updatedRows = rowData.filter((row) => row.isEdited && !row.isNew);
      if (newRows.length === 0 && updatedRows.length === 0) {
        toast.info("No new or updated german VAT to save.");
        setSaveOpen(false);
        return;
      }

      for (const row of newRows) {
        const payload = {
          vendorId: row.vendorId || 0,
          validFrom: row.validFrom
            ? moment(row.validFrom).format("YYYY-MM-DD")
            : null,
          validTo: row.validTo
            ? moment(row.validTo).format("YYYY-MM-DD")
            : null,
          
          rate: row.rate || 0,
        };

        await OAuthService.addData(germanVatUrl, payload);
      }

      for (const row of updatedRows) {
        const payload = {
          vendorId: row.vendorId || 0,
          validFrom: row.validFrom
            ? moment(row.validFrom).format("YYYY-MM-DD")
            : null,
          validTo: row.validTo
            ? moment(row.validTo).format("YYYY-MM-DD")
            : null,
       
          rate: row.rate |0,
        };

        await OAuthService.updateData(germanVatUrl, row.id, payload);
      }

      await loadGermanVat();
      toast.success("German VAT saved successfully!");
      setSaveOpen(false);
      setIsSaveEnabled(false);
      setSelectedRow(null);
    } catch (err) {
      console.error("Error saving german VAT:", err);
      toast.error("Failed to save german VAT.");
      setSaveOpen(false);
      setIsSaveEnabled(false);
      setSelectedRow(null);
    }
  };


  const validateAllRows = () => {
    return rowData.every((row) => {
      return (
        row.vendorId &&
        row.validFrom &&
        row.validTo &&
        row.rate 
   
      );
    });
  };

  const onCellEditingStopped = (params) => {
    const { colDef, value, node } = params;

    const updatedRowData = rowData.map((row, idx) =>
      idx === node.rowIndex
        ? {
            ...row,
            [colDef.field]: value,
            isEdited: !row.isNew,
          }
        : row
    );

    setRowData(updatedRowData);

    const enabled = validateAllRows(updatedRowData);
    setIsSaveEnabled(enabled);
  };

  const handleDeleteGermanVat = async () => {
    if (!selectedRow) {
      toast.info("Please select a german VAT to delete.");
      return;
    }
    if (!selectedRow.id) {
      gridRef.current.api.applyTransaction({ remove: [selectedRow] });
    
      await loadGermanVat();
      setDeleteOpen(false);
      setSelectedRow(null);
      return;
    }
    try {
      const deleted = await OAuthService.deleteData(
        germanVatUrl,
        selectedRow.id
      );

      if (deleted) {
        gridRef.current.api.applyTransaction({ remove: [selectedRow] });
       
        await loadGermanVat();

        toast.success("German  VAT deleted successfully!");
        setDeleteOpen(false);
        setSelectedRow(null);
      }
    } catch (error) {
      toast.error("Failed to delete german VAT.");
      setDeleteOpen(false);
      setSelectedRow(null);
    }
  };
  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
  }, []);

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "GermanVat.xlsx",
      sheetName: "German VAT",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const loadGermanVat = async () => {
    gridRef?.current?.api?.showLoadingOverlay();
     const startDate = formatApiDate(date);
    try {
      if(date){

        const list = await OAuthService.getList(
          `${germanVatUrl}/search/findByValidFromBeforeAndValidToAfter?date=${startDate}`
        );
        setRowData(list.data._embedded.germanVats);
      }else{
        const list = await OAuthService.getList(
        `${germanVatUrl}?page=0&size=1000`
      );
      setRowData(list.data._embedded.germanVats);
      }

      gridRef?.current?.api?.hideOverlay();

      
     
    } catch (err) {
      gridRef?.current?.api?.hideOverlay();
    toast.error(err?.response?.data?.errorMessage || err.message);
    }
  };
  useEffect(() => {
    loadGermanVat();
  }, [date]);
    const handleDateChange=(date)=>{
          const fromDate = date ? moment(date).format("YYYY-MM-DD") : null;
          setDate(fromDate);
    }
 const validateDiscount = (params) => {
  let value = Number(params.newValue);

  if (isNaN(value) || value < 0) {
    toast.warning("German VAT cannot be negative");
    value = 0;
  } else if (value > 100) {
    toast.warning("German VAT cannot exceed 100");
    value = 100;
  }

  if (params.data[params.colDef.field] !== value) {
    params.data[params.colDef.field] = value;
    params.api.refreshCells({
      rowNodes: [params.node],
      columns: [params.colDef.field],
      force: true,
    });
  }
};

  const columnDefs = [
    {
      field: "vendorId",
      headerName: "Vendor",
      type: "editableColumn",
      cellEditor: VendorIdEditorComponent,
      cellEditorParams: {
        vendorOptions,
      },
      valueFormatter: (params) => {
        const option = vendorOptionsRef.current?.find(
          (opt) => opt.value === params.value,
        );
        return option ? option.label : params.value;
      },
    },
    {
      field: "rate",
      headerName: "Vat Rate*",
      type: "editableColumn",
      onCellValueChanged: validateDiscount,
      cellRenderer: showDiscountPercent,
      cellEditor: NumericCellEditorComponent,
    },
    {
      field: "validFrom",
      headerName: "Valid From*",
      type: "editableColumn",
      cellEditor: DateFromEditorComponent,
      cellRenderer: handleDateFormat,
    },
    {
      field: "validTo",
      headerName: "Valid To*",
      type: "editableColumn",
      cellEditor: DateToEditorComponent,
      cellRenderer: handleDateFormat,
    },
  ];

  const germanVatListDropdown = () => (
    <>
    <Box className="w-full">
             
            <CustomDatePicker
              placeholder="Date"
              className="h-[30px]"
              sx={{
                "& .MuiInputBase-root": {
                  height: "30px",
                  minHeight: "30px",
                },
              }}
              format={"dd-MM-yyyy"}
              name={"Date"}
              value={date}
              handleChange={handleDateChange}
              componentsProps={{
                actionBar: { actions: ["clear"] },
              }}
            />
          </Box>
      <Tooltip title={"Add New German VAT"}>

      <Button variant="contained" color="secondary" onClick={handleAddRow}>
        <FuseSvgIcon>heroicons-solid:plus</FuseSvgIcon>
      </Button>
      </Tooltip>
      <Tooltip title={"Save German VAT"}>

      <Button
        variant="contained"
        color="secondary"
        onClick={() => setSaveOpen(true)}
        disabled={!isSaveEnabled}
        >
        <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
      </Button>
        </Tooltip>
        <Tooltip title={"Edit German VAT"}>

      <Button
        variant="contained"
        color="secondary"
        onClick={handleEditRow}
        disabled={!selectedRow}
        >
        <FuseSvgIcon>heroicons-solid:pencil</FuseSvgIcon>
      </Button>
        </Tooltip>
        <Tooltip title={"Delete German VAT"}>

      <Button
        variant="contained"
        color="secondary"
        onClick={() => setDeleteOpen(true)}
        disabled={!selectedRow}
        >
        <FuseSvgIcon>heroicons-solid:trash</FuseSvgIcon>
      </Button>
        </Tooltip>
    </>
  );
  return (
    <>
      <ListPageHeader
        componentName="German VAT"
        onBtExport={onBtExport}
        pageName="German VAT"
        headerInputFields={germanVatListDropdown()}
        gridRef={gridRef}
      />

      <div className="h-full">
        <AgGridTable
          rowData={rowData}
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          gridRef={gridRef}
          rowSelection="single"
          onSelectionChanged={onSelectionChanged}
          editable={true}
          editType={"fullRow"}
          suppressClickEdit={false}
          onCellEditingStopped={onCellEditingStopped}
          saveGridStateName={"germanVatList"}
          autoHeaderHeight
          wrapHeaderText
          tableClassName={"germanVatScreen"}
          rowGroupPanelShow="never"
        />
        {/* {totalElements > pageSize && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "1rem",
            }}
          >
            <Pagination
              count={Math.ceil(totalElements / pageSize)}
              page={page + 1}
              onChange={(e, value) => loadGermanVat(value - 1, pageSize)}
              variant="outlined"
            />
          </div>
        )} */}
      </div>

      <Dialog open={saveOpen} onClose={() => setSaveOpen(false)}>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to save German VAT?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSaveGermanVat}>Yes</Button>
          <Button onClick={() => setSaveOpen(false)} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={deleteOpen} onClose={() => setDeleteOpen(false)}>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to Delete German VAT?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteGermanVat}>Yes</Button>
          <Button onClick={() => setDeleteOpen(false)} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default GermanVat;
